import React from 'react';
import { ArticleListing } from '../components/articles/ArticleListing';
import { recruitmentArticles } from '../data/articles';

export default function ConseilsRecrutementPage() {
  return <ArticleListing articles={recruitmentArticles} section="recrutement" />;
}